import axios from 'axios'
import { ACTIVITY_URL, OTP_URL, UPLOAD_URL } from '../config'

function authHeaders(token) {
  return {
    Authorization: 'Bearer ' + token,
    'X-Stratitude-Auth': token
  }
}

export function sendOtp(email) {
  return axios.post(OTP_URL, {
    action: 'send',
    email: email
  })
}

export function verifyOtp(email, otp) {
  return axios.post(OTP_URL, {
    action: 'verify',
    email: email,
    otp: otp
  })
}

export function logoutSession(token) {
  return axios.post(
    OTP_URL,
    {
      action: 'logout',
      auth_token: token
    },
    {
      headers: authHeaders(token)
    }
  )
}

export function uploadFiles(token, files, onProgress) {
  var formData = new FormData()

  // Shared-hosting/FastCGI configurations can strip Authorization on multipart
  // requests, so retain the existing token fallback in the request body.
  formData.append('auth_token', token)

  files.forEach(function (file) {
    formData.append('files[]', file, file.name)
  })

  return axios.post(UPLOAD_URL, formData, {
    headers: authHeaders(token),
    onUploadProgress: onProgress
  })
}

export function fetchShareActivity(token) {
  return axios.post(
    ACTIVITY_URL,
    { auth_token: token },
    { headers: authHeaders(token) }
  )
}

export function deleteShare(token, shareId) {
  return axios.post(
    ACTIVITY_URL,
    {
      action: 'delete',
      share_id: shareId,
      auth_token: token
    },
    { headers: authHeaders(token) }
  )
}
